import { T, useTranslate } from '@tolgee/react';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import HybridForm from '../HybridForm/HybridForm';

const QuotesForm = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>
        <T
          keyName="request_curipod_quote_title"
          defaultValue="Bring Curipod to your
School or District"
        />
      </h1>
      <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>
        <T
          keyName="fill_out_form_quote_description"
          defaultValue="Request a quote by completing the form below."
        />
        <br />
        <T
          keyName="fill_out_form_quote_description_2"
          defaultValue="A member of our team will reach out shortly to discuss your unique needs and answer any questions you have."
        />
      </h4>
      <HybridForm
        typeformUrl="https://9uq31r57i3q.typeform.com/to/rdHtD0FA"
        metricEventNamePrefix="Quotes"
        showTypeformEnding={true}
      />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  background: ${theme.colors.background};
`;

export default QuotesForm;
